// The API is served by the same Worker as the app, so requests are same-origin by default.
// For `npm run client` against `npm run dev`, set REACT_APP_API_HOST=http://localhost:8787
export const host = process.env.REACT_APP_API_HOST || '';
export const loadUserRoute = host + `/api/auth`;
export const registerRoute = host + `/api/users`;
export const loginRoute = host + `/api/auth`;
export const deleteAccountRoute = host + `/api/users`;
export const getUserFriendsRoute = host + `/api/users/getUserFriends`;
export const getFriendRequestsRoute = host + `/api/users/getFriendRequests`;
export const getFriendMessagesRoute = host + `/api/messages/getFriendMessages`;
export const getGroupMessagesRoute = host + `/api/messages/getGroupMessages`;
export const sendMessageRoute = host + `/api/messages/sendMessage`;
export const updateUserProfileRoute = host + `/api/users/updateUserProfile`;
export const searchUserContactsRoute = host + `/api/users/searchUserContacts`;
export const sendFriendRequestRoute = host + `/api/users/sendFriendRequest`;
export const acceptFriendRequestRoute = host + `/api/users/acceptFriendRequest`;
export const checkFriendshipStatus = host + `/api/users/checkFriendshipStatus`;
export const createNewGroupRoute = host + `/api/groups/createNewGroup`;
export const getUserGroupsRoute = host + `/api/groups/getUserGroups`;
export const addToGroupRoute = host + `/api/groups/addToGroup`;
